import { render, staticRenderFns } from "./BbeeCampanasComercialesCC.vue?vue&type=template&id=64183a21"
import script from "./BbeeCampanasComercialesCC.vue?vue&type=script&lang=js"
export * from "./BbeeCampanasComercialesCC.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports